import { render, staticRenderFns } from "./ControlSubAdmin.vue?vue&type=template&id=03441a66&"
import script from "./ControlSubAdmin.vue?vue&type=script&lang=js&"
export * from "./ControlSubAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports